import { defineMessages } from 'react-intl';

export default defineMessages({
    primaryAddress: {
        id: 'quoteandbind.bop.directives.bop-location-header.(Primary)',
        defaultMessage: '(Primary)',
    }
});
